import { Container, Box, Typography,Button,TextField}
    from '@mui/material';
import axios from '../../axios';
import {useEffect,useState} from "react";
import { useNavigate } from 'react-router-dom';

export default function Login({setToken, setShowNav}) {
    useEffect(() => {
        setShowNav(false);
    }, []);
    const [showPseudoError, setShowPseudoError] = useState(false);
    const [showPseudoErrorText, setShowPseudoErrorText] = useState(false);
    const [showPasswordError, setShowPasswordError] = useState(false);
    const [showPasswordErrorText, setShowPasswordErrorText] = useState(false);

    const navigate = useNavigate();

    const validateData = (pseudo,password) => {
        if (pseudo == "") {
            setShowPseudoError(true);
            setShowPseudoErrorText("Veuillez remplir ce champ.");
        }
        if (password == "") {
            setShowPasswordError(true);
            setShowPasswordErrorText("Veuillez remplir ce champ.");
        }
        if (pseudo == "" || password == "") {
            return false;
        }
        return true;
    }

    const handleSubmit = async event => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        if (validateData(data.get('email'),data.get('password'))) {
            axios.post(`${axios.defaults.apiURL}/user/token/jwt`, {
                JWTInput: {
                    username: data.get('email'),
                    password: data.get('password')
                }
            }, { headers: { "Content-Type": "application/vnd.ibexa.api.JWTInput+json", "Accept" :"application/vnd.ibexa.api.ContentInfo+json"} } )
                .then(function (response) {
                    setToken(response.data.JWT._token);
                    setShowNav(true);
                    navigate('/');
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    };

    return (
        <Container component="main" maxWidth="xs" sx= {{p:1, mt: 8, backgroundColor: '#FFFFFF'}}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography variant="h4">
                    Connectez-vous
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField
                        error={showPseudoError}
                        helperText={showPseudoErrorText}
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <TextField
                        error={showPasswordError}
                        helperText={showPasswordErrorText}
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />
                    {/*<FormControlLabel*/}
                    {/*    control={<Checkbox value="remember" color="primary" />}*/}
                    {/*    label="Remember me"*/}
                    {/*/>*/}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Sign In
                    </Button>
                    {/*<Grid container>*/}
                    {/*    <Grid item xs>*/}
                    {/*        <Link href="#" variant="body2">*/}
                    {/*            Forgot password?*/}
                    {/*        </Link>*/}
                    {/*    </Grid>*/}
                    {/*    <Grid item>*/}
                    {/*        <Link href="#" variant="body2">*/}
                    {/*            {"Don't have an account? Sign Up"}*/}
                    {/*        </Link>*/}
                    {/*    </Grid>*/}
                    {/*</Grid>*/}
                </Box>
            </Box>
        </Container>
    )
}